export default "__VITE_ASSET__CriOFmO3__"